import React from 'react'
import update from 'immutability-helper'
import Dropzone from 'react-dropzone'
import {Grid, CircularProgress} from '@material-ui/core'

export default class UploadImageComponent extends React.Component {
  state = {
    uploading: false,
    editing: {},
  }

  onDrop = async (acceptedFiles, _rejectedFiles) => {
    const images = [...this.props.images]
    if (acceptedFiles.length > 0) {
      this.setState({uploading: true})
      for (let i = 0; i < acceptedFiles.length && images.length < 10; i++) {
        const file = acceptedFiles[i]
        images.push({src: file.preview, file})
      }

      this.setState({uploading: false})
      this.props.onUpdate('images', images)
    }
  }

  handleRemoveImage = index => {
    const images = update(this.props.images, {$splice: [[index, 1]]})
    this.props.onUpdate('images', images)
  }

  handleMouseEnter = index => {
    this.setState({editing: {[index]: true}})
  }

  handleMouseLeave = e => {
    this.setState({editing: {}})
  }

  render() {
    return (
      <div>
        <div style={{height: '200px'}}>
          <Dropzone
            maxSize={1024 * 1024 * 5}
            accept="image/jpeg, image/png"
            onDrop={this.onDrop}
            disableClick={this.props.images.length >= 10}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '1em',
              width: '100%',
              height: '100%',
              borderRadius: '0',
              backgroundColor: '#F0F0F0',
            }}
          >
            {this.state.uploading ? (
              <CircularProgress />
            ) : (
              <p>
                {this.props.placeholder
                  ? this.props.placeholder
                  : 'Click or drop product image here.'}
              </p>
            )}
          </Dropzone>
        </div>
        <div style={{backgroundColor: 'rgb(240,240,240)', padding: '1em'}}>
          <Grid alignItems="center" container spacing={24}>
            {this.props.images &&
              this.props.images.map((img, i) => (
                <Grid key={i} item xs={3}>
                  <div
                    style={{position: 'relative'}}
                    onMouseEnter={_e => this.handleMouseEnter(i)}
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <img src={img.src} alt="" />
                    {this.state.editing[i] && (
                      <div
                        style={{
                          cursor: 'pointer',
                          position: 'absolute',
                          bottom: '0',
                          left: '0',
                          right: '0',
                          height: '40px',
                          background: 'rgba(255,255,255,0.9)',
                          color: 'rgba(0, 0, 0, 0.87)',
                          padding: '10px',
                          textAlign: 'center',
                        }}
                        onClick={_e => this.handleRemoveImage(i)}
                      >
                        Remove Image
                      </div>
                    )}
                  </div>
                </Grid>
              ))}
          </Grid>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/products/components/UploadImageComponent.js